<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :filter="filter"
      :pagination="pagination"
      resource="pages"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class Pages extends Vue {

  pagination = {}

  filter = [
    {
      prop: 'name_cont',
      label: '名字',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'en_name_cont',
      label: '英文名',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'content_cont',
      label: '内容',
      form: {
        component: 'search'
      }
    },
  ]

  table = {
    data: []
  };

  get columns() {
    return createColumns.call(this)
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/pages', { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }
}
</script>
